const experiencesEn = [
  {
    title: "Group Chief Technology & Solutions Officer",
    company: "Shared Resource Hub: Click2Secure, Payd, Starz TPA, Seguro, Trustcare",
    period: "Dec 2025 to Present",
    location: "Remote",
    description:
      "Directing a centralized technology and solutions hub providing executive leadership, security architecture, and operational excellence across group entities. Directed technical and infrastructure remediation for Payd to achieve full-scope PCI DSS v4.0.1 Service Provider compliance; oversaw group-wide ISO 27001:2022 certification; steering ADHICS compliance with Abu Dhabi DOH; implemented automated AML/CTF transaction screening. Directed core payment gateway engineering in Rust and Laravel, multi-cloud DR architectures (AWS/Azure), defense-in-depth perimeter security (CrowdSec, Suricata IDS/IPS, OPNsense/pfSense firewalls, OWASP CRS, AWS WAF & Network Firewall, Azure Firewall & WAF), and successfully led emergency zero-data-loss failover and migration during the AWS UAE regional crisis under heavy load.",
    skills: [
      "PCI DSS v4.0.1",
      "ISO 27001:2022",
      "ADHICS & DOH",
      "CrowdSec & Suricata (IDS/IPS)",
      "AWS & Azure WAF / Firewalls",
      "OWASP CRS & ModSecurity",
      "OPNsense / pfSense",
      "Rust (Actix-web)",
      "PHP (Laravel)",
      "Payment Gateways",
      "Crisis DR & Incident Migration",
      "Wazuh (HIPS/IDS)",
      "Automated AML / CTF",
      "Shared Hub Leadership"
    ],
  },
  {
    title: "Chief Technology Officer",
    company: "Global Ventures UAE (PAYD & CLICK2SECURE)",
    period: "Jan 2025 to Dec 2025",
    location: "Remote",
    description:
      "Modernized payment infrastructure, established strict code quality and security standards, and fulfilled mission-critical enterprise B2B partner integrations across Global Ventures UAE's fintech portfolio. Spearheaded SOC and observability integrations, automated deployment pipelines, and partner compliance attestations (AOC/ROC).",
    skills: [
      "Fintech Infrastructure",
      "System Architecture",
      "B2B Platform Integrations",
      "Security Operations",
      "DevOps & CI/CD",
      "Cloud Architecture"
    ],
  },
  {
    title: "Head of Information Technology",
    company: "PAYD & CLICK2SECURE",
    period: "Aug 2024 to Jan 2025",
    location: "Hybrid",
    description:
      "Led the IT department overseeing core infrastructure, corporate security baselines, network architecture, and digital tooling. Implemented host-level security controls, centralized error monitoring, and coordinated technical audits.",
    skills: [
      "IT Infrastructure",
      "Network Security",
      "Cloud Operations",
      "Systems Hardening",
      "Audit Compliance"
    ],
  },
  {
    title: "Software Engineer (Part-time)",
    company: "PAYD",
    period: "Mar 2024 to Mar 2025",
    location: "Remote",
    description:
      "Spearheaded the complete modernization of the PAYD merchant and client web platform. Engineered a secure, high-performance, responsive frontend and integrated robust API communication protocols ready for financial compliance standards.",
    skills: [
      "React",
      "JavaScript / TypeScript",
      "REST APIs",
      "Modern Web Architecture",
      "UI Engineering"
    ],
  },
  {
    title: "Software Engineer",
    company: "Ouedkniss / واد كنيس",
    period: "Feb 2022 to Aug 2024",
    location: "Kouba, Algiers, Algeria",
    description:
      "Engineered high-throughput web services for Algeria's largest online marketplace serving millions of active users. Optimized critical search and browsing latency bottlenecks, developed scalable backend microservices, and delivered responsive user-facing features using modern TypeScript and web stacks.",
    skills: [
      "TypeScript",
      "High-Traffic Systems",
      "Performance Optimization",
      "Microservices",
      "Scalable Web APIs"
    ],
  },
  {
    title: "Full-Stack Developer & Solutions Architect",
    company: "Freelance & Consulting",
    period: "Jan 2014 to Mar 2022",
    location: "Remote",
    description:
      "Architected and developed custom web platforms, e-commerce engines, and high-performance software solutions for diverse international clients. Designed clean relational schemas, high-efficiency API backends, and responsive client interfaces.",
    skills: [
      "Full-Stack Engineering",
      "Next.js & React",
      "PHP & Laravel",
      "Database Architecture",
      "Systems Design"
    ],
  },
  {
    title: "UI/UX Designer",
    company: "Freelance",
    period: "Jun 2013 to Mar 2022",
    location: "Remote",
    description:
      "Designed user-centered digital interfaces, design systems, and cross-platform UX workflows for web and mobile products. Established strong foundations in typographic hierarchy, spatial design, and accessible user flows.",
    skills: [
      "UI/UX Design",
      "Design Systems",
      "User Flows & Wireframing",
      "Accessibility (a11y)",
      "Affinity Suite"
    ],
  },
];

export default experiencesEn;
